import "./styles.css";
import { useParams, Link, useLocation, useHistory } from "react-router-dom";
import { useEffect } from "react";

function Learnmore() {
  const { id } = useParams();
  const location = useLocation();
  const history = useHistory();

  const title = [
    "",
    "ALGOS",
    "APPLICATION DEV",
    "DEV OPS",
    "EMBEDDED SYSTEMS & ELECTRONICS",
    "ROBOTICS",
    "MACHINE LEARNING",
    "CYBERSECURITY",
    "NETWORKS",
    "BLOCKCHAIN"
  ];

  const description = [
    "",
    "The Algorithms profile (or Algos) primarily focuses on competitive programming. We train for and participate in multiple programming contests, especially the ACM ICPC. With an emphasis on improving the coding culture on campus, we conduct multiple contests, workshops, and discussions throughout the year. But that’s not all! Members of our team have varied interests. We participate in hackathons and take up projects in other domains",
    "The Application Development domain brings together the dynamic world of App Development with the innovative sphere of Web Development. As a unified team of creative thinkers and skilled developers, we are dedicated to crafting both mobile applications and full-stack web applications that not only meet the needs of users but also push the boundaries of what's possible in digital creation. Our domain is a hub for those who are passionate about leveraging their coding skills, design flair, and innovative ideas to create seamless, scalable, and powerful applications that cater to a diverse audience. Whether it's developing applications for mobile platforms, managing complex server-side operations, or designing responsive web applications, our goal is to merge these talents to develop holistic solutions that enhance user engagement and drive technological advancement. ",
    "While the core development team optimises the development process, the devOps team optimises the deployment process. This subdomain concerns itself with deploying websites, server management and optimising production ready softwares.",
    "This domain is a combination of both hardware and software, based on microcontrollers, microprocessors, and other Integrated Circuits.",
    "Spider Robotics is dedicated to advancing the field of robotics through research and innovation. Our primary goal is to publish our research findings in prestigious organizations such as IEEE and ICRA. Our work spans various frontiers of robotics, including underwater robotics, aerial robotics, mobile and autonomous robots, and much more. ",
    "ML domain does independent Research and Development in state-of-the-art research topics which are basically driving the AI industry now. We primarily focus on Computer Vision, Natural Language Processing, and Reinforcement learning . We also work on many interdisciplinary projects which involve robotics and software domains of the club. ",
    "The Cybersecurity domain is dedicated to the critical mission of protecting digital environments from a broad spectrum of threats. As experts in this field, we focus on the development and implementation of advanced security protocols, risk assessment strategies, and proactive defense mechanisms to safeguard sensitive data and ensure the integrity of information systems. Our team is composed of skilled professionals who are continuously engaged in staying ahead of the latest security trends and vulnerabilities, employing cutting-edge technologies and methodologies. Through rigorous training, research, and collaboration, we are committed to fortifying the digital landscape, making it resilient against cyber attacks and ensuring the privacy and security of users and organizations worldwide.",
    "The Networks domain specializes in the architecture, implementation, and management of complex networking infrastructures. By integrating the latest advancements in network security, performance optimization, and cloud-based solutions, we ensure that our systems are secure, reliable, and ready to meet the demands of modern digital communication. Our team of experts is committed to continuous learning and improvement, staying abreast of emerging technologies and industry standards to provide cutting-edge networking solutions that power organizations and drive technological innovation forward.",
    "The Blockchain and Decentralized Networks domain is dedicated to exploring and advancing the frontier of blockchain technology and decentralized systems. This domain focuses on developing secure, transparent, and efficient solutions using blockchain. Our work encompasses the creation and management of decentralized applications (DApps) to foster a new era of internet where autonomy, user privacy, and trust are paramount. By leveraging the inherent security features of blockchain and the power of distributed ledger technology, we strive to innovate and build systems that ensure data integrity, facilitate peer-to-peer transactions, and empower users through decentralized control."

  ];

  const subdomains = [
    "",
    "",
    "",
    "",
    ["Electronics", "Embedded Systems"],
    ["Mechanics","Control Systems/Simulation", "Embedded Systems"],
    "",
    "",
    "",
    ""
  ];

  useEffect(() => {
    if (location.state && location.state.scrollY) {
      window.scrollTo(0, location.state.scrollY);
    }
  }, [location.state]);

  const handleGoBack = () => {
    history.goBack();
  };

  return (
    <div className="body">
      <div className="description">
        <Link to="/" className="back" onClick={handleGoBack}>
          {" "}
          Back{" "}
        </Link>
        <p className="title"> {title[id]} </p>
        <p className="text"> {description[id]} </p>
        {subdomains[id].length > 1 ? (
          <div>
            <p className="subtitle"> SUBDOMAINS </p>{" "}
            {subdomains[id].map((domain, index) => (
              <p key={index} className="subdomains">
                {" "}
                {index + 1 + ". " + domain}{" "}
              </p>
            ))}
            <p className="notes">
              <b> NOTE </b> You can opt for any one domain. Inside that domain,
              you can opt for any one of its sub - domains.{" "}
            </p>
          </div>
        ) : (
          <> </>
        )}{" "}
      </div>{" "}
    </div>
  );
}

export default Learnmore;
